<template>
    <div id="znkqdcSystem">
        <!--banner区域-->
        <div class="bannerWrap">
            <div class="contentWrap">
                <!--动态区域-->
                <div class="containerWrap">
                    <div class="container">
                        <div class="cube cube--1">
                            <div class="side side--back">
                                <div class="side__inner"></div>
                            </div>
                            <div class="side side--left">
                                <div class="side__inner"></div>
                            </div>
                            <div class="side side--right">
                                <div class="side__inner"></div>
                            </div>
                            <div class="side side--top">
                                <div class="side__inner"></div>
                            </div>
                            <div class="side side--bottom">
                                <div class="side__inner"></div>
                            </div>
                            <div class="side side--front">
                                <div class="side__inner"></div>
                            </div>
                        </div>
                        <div class="cube cube--2">
                            <div class="side side--back">
                                <div class="side__inner"></div>
                            </div>
                            <div class="side side--left">
                                <div class="side__inner"></div>
                            </div>
                            <div class="side side--right">
                                <div class="side__inner"></div>
                            </div>
                            <div class="side side--top">
                                <div class="side__inner"></div>
                            </div>
                            <div class="side side--bottom">
                                <div class="side__inner"></div>
                            </div>
                            <div class="side side--front">
                                <div class="side__inner"></div>
                            </div>
                        </div>
                        <div class="cube cube--3">
                            <div class="side side--back">
                                <div class="side__inner"></div>
                            </div>
                            <div class="side side--left">
                                <div class="side__inner"></div>
                            </div>
                            <div class="side side--right">
                                <div class="side__inner"></div>
                            </div>
                            <div class="side side--top">
                                <div class="side__inner"></div>
                            </div>
                            <div class="side side--bottom">
                                <div class="side__inner"></div>
                            </div>
                            <div class="side side--front">
                                <div class="side__inner"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="content">
                    <div class="contentTitle">智能客群洞察系统</div>
                    <div class="contentVal">
                        <span>帮助企业深度理解用户群特征，协助企业洞察目标客户的人群特征和线上、线下行为轨迹，有</span>
                        <span>针对性地制定营销、运营策略</span>
                    </div>
                    <button class="btn" @click="showAlertFlag=true">立即咨询</button>
                </div>
            </div>
        </div>
        <!--内容区-->
        <div class="znkqdcSystemConWrap">
            <!--例子-->
            <div class="exampleWrap">
                <div class="exampleBox">
                    <div class="left">
                        <div class="leftList" v-for="(item,index) in leftData" :key="index">
                            <div class="name">
                                {{item.name}} <span>{{item.work}}</span>
                            </div>
                            <div class="wordWrap" v-html="item.val"></div>
                        </div>
                    </div>
                    <div class="right">
                        <div class="rightTitle">您以为自己很了解用户？</div>
                        <div class="rightList" v-for="(item,index) in rightData" :key="index"
                             @click="chooseExampleEvent(index)">
                            <span></span>
                            <p v-html="item.val"></p>
                        </div>
                    </div>
                </div>
            </div>
            <!--产品设计-->
            <div class="productWrap">
                <canvas id="canvasBox"></canvas>
                <div class="headline">产品设计</div>
                <div class="productListWrap">
                    <div class="productList">
                        <div class="numBox"><img src="../../assets/img/num/01.png"/></div>
                        <div class="listTitle">
                            从不同方向<br/>对客群进行洞察分析
                        </div>
                        <div class="listVal">
                            汇集海量参数，利用神经网络计算对用户ID表单、搜索关键词、LBS位置几大模块圈定目标人群进行洞察分析
                        </div>
                    </div>
                    <div class="productList">
                        <div class="numBox"><img src="../../assets/img/num/02.png"/></div>
                        <div class="listTitle">
                            根据选定模块输出<br/>各维度的分析结果
                        </div>
                        <div class="listVal">
                            基于人口属性、社会属性、兴趣爱好、位置分布、品牌偏好、媒体关注、网站关注等维度，利用强大的画像技术进行多维度、多标签的交叉分析，直达消费喜好、刻画心理偏好，还原用户的真实画像
                        </div>
                    </div>
                    <div class="productList">
                        <div class="numBox"><img src="../../assets/img/num/03.png"/></div>
                        <div class="listTitle">
                            导出完整的<br/>目标客群洞察分析报告
                        </div>
                        <div class="listVal">
                            提供人群画像的原始Excel全量参数，帮助企业深度理解用户群特征，协助企业洞察目标客户的人群特征和线上、线下行为轨迹，有针对性地制定营销、运营策略
                        </div>
                    </div>
                </div>
            </div>
            <!--应用价值-->
            <div class="applicationValue">
                <div class="headline" style="margin-bottom: 50px;">应用价值</div>
                <div class="applicationValueBox">
                    <div class="applicationValueList">
                        <img src="../../assets/img/znkqdcSystem/受众.png"/>
                        <div class="listTitle">实时了解受众群体</div>
                        <div class="listVal">
                            通过智能客群洞察系统，帮助企业深度理解用户群特征和线上、线下行为轨迹，为后续的营销、运营策略做依据
                        </div>
                    </div>
                    <div class="applicationValueList">
                        <img src="../../assets/img/znkqdcSystem/方案.png"/>
                        <div class="listTitle">灵活制定营销方案</div>
                        <div class="listVal">
                            企业可以针对不同用户群进行洞察分析，基于分析结果组织不同的运营活动或制定个性化营销策略，提升运营、营销效率
                        </div>
                    </div>
                    <div class="applicationValueList">
                        <img src="../../assets/img/znkqdcSystem/市场.png"/>
                        <div class="listTitle">实时关注市场动态</div>
                        <div class="listVal">
                            基于人群画像报告，企业还可实时了解市场动态与竞争对手状态，持续推出具有自身品牌特色及差异化的服务
                        </div>
                    </div>
                </div>
            </div>
            <!--案例-->
            <div class="caseWrap">
                <div class="headline">案例</div>
                <div class="caseBox">
                    <div class="caseList">
                        <img src="../../assets/img/exampleImg/某汽车企业的精准营销.png" class="leftImg"/>
                        <div class="rightVal">
                            <div class="rightValTitle">某汽车企业的精准营销</div>
                            <div class="rightValText">
                                某企业把用户画像可以分为三大类：用户的基本属性、汽车的基本属性、经销商的基本属性，根据客户的现有数据建立模型，分析现有标签对客户意向的影响。根据多个标签属性综合分析可以得到三类用户：意向阶段、对比阶段、决策阶段，实现精准洞察客群
                            </div>
                        </div>
                    </div>
                    <div class="caseList">
                        <img src="../../assets/img/exampleImg/某市公安教育的发展与改革.png" class="leftImg"/>
                        <div class="rightVal">
                            <div class="rightValTitle">某市公安教育的发展与改革</div>
                            <div class="rightValText">
                                在信息化建设过程中,某市公安教育积累海量数据,数据覆盖了学习者、教师、院校管理者等层面。基于用户画像技术对这些数据进行提取和聚合分析洞察群众,有利于促进公安教育的均衡发展、助推公安院校提升教学质量、促进师生个性化发展,进而推动公安教育的改革
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--相关产品-->
            <div class="relevantProduct">
                <div class="headline">相关产品</div>
                <!--产品列表-->
                <div class="relevantProductListWrap">
                    <div class="relevantProductList" @click="toPage('/modelFactory')" style="margin-right: 144px;">
                        <img src="../../assets/img/bigIcon/模型工厂.png"/>
                        <span>模型工厂</span>
                    </div>
                    <div class="relevantProductList" @click="toPage('/factorServices')" style="margin-right: 144px;">
                        <img src="../../assets/img/bigIcon/因子服务.png"/>
                        <span>因子服务</span>
                    </div>
                    <div class="relevantProductList" @click="toPage('/smartLabel')" style="margin-right: 128px;">
                        <img src="../../assets/img/bigIcon/智能标签.png"/>
                        <span>智能标签</span>
                    </div>
                    <div class="relevantProductList" @click="toPage('/znyxSystem')">
                        <img src="../../assets/img/bigIcon/智能营销系统.png"/>
                        <span>智能营销系统</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="alertBox" v-show="showAlertFlag">
            <div class="alertBoxHeader">
                <span>服务咨询</span>
                <img src="../../assets/关闭.png" height="11" width="11" @click="showAlertFlag=false"/>
            </div>
            <div class="alertBoxVal">
                <div>为您提供售前购买咨询、产品推荐等</div>
                <p>电话：<span>0755-86969845</span>（工作日 9:30-18:30）</p>
                <p>微信：ylw2539</p>
                <p>邮箱：yu@houselai.com</p>
            </div>
        </div>

    </div>
</template>

<script>
    import znkqdxSystemFun from "../../assets/js/znkqdxSystem"

    export default {
        name: "znkqdcSystem",
        data() {
            return {
                proIndex: 1,
                /*数据*/
                rightData: [
                    {val: "洞察客群消费趋势抢先机"},
                    {val: "让您的产品离消费者更近一步"},
                ],
                allData: {
                    0: [
                        {
                            name: "孟先生", work: "某企业副总经理",
                            val: "客流数据是线上重要的数据，可以帮助网站了解其经营效率，并以此为基" +
                                "础不断改变其经营手段，提高经营业绩。实体商业同样也需要洞察客户画像、" +
                                "流量、成交额、滞留时间等等来帮助经营者更好地调整他们的经营策略<br/>" +
                                "善用大数据技术依托客群洞察系统，对比人为分析判断更精准地分析出客" +
                                "群的用户需求，辅助企业更好地了解当前状况及未来趋势，更快地抢占先机"
                        },
                        {
                            name: "樊先生", work: "某创业公司CEO",
                            val: "导致一个品牌是否能茁壮成长有很多因素，但是否能够很好的理解消费者，并" +
                                "对消费者心理、行为变化做出及时的反应是关键的一环，这也就是通常大家所" +
                                "说的“消费者洞察”，也就是客群洞察<br/>" +
                                "依赖大数据技术分析得到的客群洞察系统就能实现上述需求，帮助企业了解客群" +
                                "需求的变化"
                        },
                        {
                            name: "张先生", work: "某商场销售主管",
                            val: "实体商业面对竞争越来越激烈的行业发展趋势，通过洞察客流数据，抓取客群" +
                                "行动轨迹，了解顾客的购物类型与产品偏好，结合客群结构为运营战略制定奠定基" +
                                "础<br/>" +
                                "大数据建模技术可以很好地洞察分析顾客光顾频率比例，来访周期清晰展现，及时" +
                                "掌握客群结构，调整销售策略"
                        }
                    ],
                    1: [
                        {
                            name: "胡女士", work: "资深营销人员",
                            val: "某学者这样描述“消费者洞察”：消费者洞察意味着对于消费者的深入理解，" +
                                "并将这样的理解用于帮助消费者实现他们的需要。消费者洞察也意味着智慧的" +
                                "机构能够以此更好的定位自己，从而满足顾客或者利益相关者的需求<br/>" +
                                "通过分析消费者需，靠近消费者需求为企业战略调整作参考，这些将会成为企" +
                                "业越来越注重的经营战略指标"
                        },
                        {
                            name: "张先生", work: "某车企销售主管",
                            val: "一向以“消费者导向”著名专家表示，在进行消费者理解时，用民族志的方法，" +
                                "在消费者生活的场景中去观察和理解行为，用投射和Laddering的方式来建立架" +
                                "构，最后用模拟购物来验证商业假设<br/>" +
                                "利用大数据从产品属性，功能性利益，情感性利益，价值观不同层面来分析消费" +
                                "者的不同层次的偏好和动机，了解赢得他们好感的因素"
                        },
                        {
                            name: "高女士", work: "某日化公司销售人员",
                            val: "营销能力是当代企业的核心竞争力，其本质是吸引顾客和保留顾客；另一方" +
                                "面顾客是公司的核心资产。因为只有吸引、留住了顾客，企业才能获利生存和发" +
                                "展下去，而留住用户就要了解用户、亲近用户<br/>" +
                                "用大数据洞察客户，对顾客需求的探索和满足，当产品能从满足顾客生理需要上" +
                                "升到情感和精神需要，就能更好的吸引顾客和留住顾客"
                        }
                    ],
                },
                leftData: [],
                showAlertFlag: false

            }
        },
        created() {
            /*初始化案例*/
            this.leftData = this.allData[0];
        },
        mounted() {
            /*canvas 粒子背景*/
            znkqdxSystemFun();
            /*淡入淡出效果*/
            window.addEventListener('scroll', this.scrollFun);
            this.scrollFun();
        },
        methods: {
            toPage(page) {
                this.$router.push({path: page});
            },
            scrollFun() {
                this.$animate(document.getElementsByClassName("content")[0], "fadeInUp");
                this.$animate(document.getElementsByClassName("exampleWrap")[0], "fadeInUp");
                this.$animate(document.getElementsByClassName("productWrap")[0], "fadeInUp");
                this.$animate(document.getElementsByClassName("applicationValue")[0], "fadeInUp");
                this.$animate(document.getElementsByClassName("caseWrap")[0], "fadeInUp");
                this.$animate(document.getElementsByClassName("relevantProduct")[0], "fadeInUp");
            },
            /*切换案例数据*/
            chooseExampleEvent(index) {
                this.leftData = this.allData[index];
            }
        },
        beforeDestroy() {
            /*销毁监听*/
            window.removeEventListener('scroll', this.scrollFun);
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../assets/css/znkqdcSystem.css";

    #znkqdcSystem {
        .bannerWrap {
            background: #00051D;

            .containerWrap {
                position: absolute;
                right: 100px;
                top: 50%;
                transform: translateY(-50%);
            }
        }

        .znkqdcSystemConWrap {
            .exampleWrap {
                background: url("../../assets/bgImg.png");
                background-size: cover;
                padding: 80px 0 120px;
            }

            .exampleBox {
                display: flex;
                align-items: center;
                justify-content: flex-start;
                width: 1200px;
                margin: 0 auto 120px;
                padding: 0 0 0 76px;

                .left {
                    width: 458px;
                    padding-top: 44px;
                    margin-right: 128px;

                    .leftList {
                        padding: 20px 20px 20px 31px;
                        margin-bottom: 16px;
                        border-radius: 4px;
                        border: 1px solid #EAEEF4;
                        background: #fff;

                        &:last-child {
                            margin-bottom: 0;
                        }

                        .name {
                            margin-bottom: 4px;
                            font-size: 14px;
                            color: #1B2D35;

                            span {
                                margin-left: 10px;
                                font-size: 12px;
                                color: #40B0FF;
                            }
                        }

                        .wordWrap {
                            opacity: 0.6;
                            margin-bottom: 4px;
                            font-size: 12px;
                            color: #152346;
                            text-align: justify;
                            line-height: 24px;

                            &:last-child {
                                margin-bottom: 0;
                            }
                        }
                    }
                }

                .right {
                    .rightTitle {
                        margin-bottom: 60px;
                        font-size: 30px;
                        color: #152346;
                    }

                    .rightList {
                        display: flex;
                        align-items: center;
                        margin-bottom: 40px;
                        line-height: 22px;
                        cursor: pointer;

                        &:last-child {
                            margin-bottom: 0;
                        }

                        span {
                            display: inline-block;
                            width: 12px;
                            height: 12px;
                            border-radius: 50%;
                            margin-right: 22px;
                            background: #22A5FF;
                        }

                        p {
                            font-size: 16px;
                            color: #152346;
                        }
                    }
                }
            }

            .productWrap {
                position: relative;
                height: 630px;
                padding-top: 60px;
                background: #000519;

                .headline {
                    margin-bottom: 120px;
                    color: #FFFFFF;
                }

                #canvasBox {
                    position: absolute;
                    left: 0;
                    top: 0;
                }

                .productListWrap {
                    display: flex;
                    justify-content: space-between;
                    width: 1200px;
                    margin: 0 auto;
                    padding: 0 64px;

                    .productList {
                        position: relative;
                        width: 260px;

                        .numBox {
                            position: absolute;
                            left: 0;
                            top: -38px;

                        }

                        .listTitle {
                            position: relative;
                            z-index: 500;
                            margin-bottom: 24px;
                            font-size: 24px;
                            color: #FFFFFF;
                            line-height: 34px;
                        }

                        .listVal {
                            opacity: 0.8;
                            font-size: 12px;
                            color: #FDFDFD;
                            line-height: 22px;
                            text-align: justify;
                        }
                    }
                }
            }

            .applicationValue {
                background: url("../../assets/bgImg.png");
                background-size: cover;
                padding-top: 120px;
                padding-bottom: 114px;

                .applicationValueBox {
                    display: flex;
                    justify-content: space-between;
                    width: 1200px;
                    margin: 0 auto;

                    .applicationValueList {
                        width: 300px;
                        text-align: center;

                        img {
                            width: 50px;
                            height: 50px;
                            margin-bottom: 24px;
                        }

                        .listTitle {
                            margin-bottom: 12px;
                            font-size: 20px;
                            color: #152346;
                        }

                        .listVal {
                            opacity: 0.7;
                            font-size: 12px;
                            color: #152346;
                            line-height: 22px;
                            text-align: justify;
                        }
                    }
                }
            }
        }

        .caseWrap {
            margin-top: 18px;

            .caseBox {
                display: flex;
                align-items: center;
                justify-content: space-between;
                width: 1200px;
                margin: 0 auto;

                .caseList {
                    display: flex;
                    align-items: flex-start;

                    .leftImg {
                        width: 192px;
                        height: 186px;
                        margin-right: 16px;
                    }

                    .rightVal {
                        padding-top: 16px;

                        .rightValTitle {
                            opacity: 0.6;
                            margin-bottom: 10px;
                            font-size: 20px;
                            color: #152346;
                        }

                        .rightValText {
                            width: 339px;
                            opacity: 0.4;
                            font-size: 12px;
                            color: #152346;
                            line-height: 24px;
                        }
                    }
                }
            }
        }

        .relevantProduct {
            width: 704px;
        }
    }
</style>
